<template>
  <StructuredData type="listing" v-if="listing_loaded" :data="listing"/>
  <div id="main" style="opacity: 1;">
    <!-- Header -->
    <app-header/>
    <MobileFixedMenu/>
    <!-- Header End -->

    <!-- Breadcrumb Section Start -->
    <section class="breadscrumb-section pt-0">
      <div class="container-fluid-lg">
        <div class="row">
          <div class="col-12">
            <div class="breadscrumb-contain">
              <h1 style="font-size:18px">
                {{ listing?.name }}
              </h1>
              <nav>
                <ol class="breadcrumb mb-0">
                  <li class="breadcrumb-item">
                    <a href="/">
                      <i class="fa-solid fa-house"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    {{ listing?.category?.name }}
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    <h1 style="font-size: 18px">
                      {{ listing?.name }}
                    </h1>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Breadcrumb Section End -->

    <!-- Product Left Sidebar Start -->
    <section class="product-section">
      <div class="container-fluid-lg">
        <div class="row">
          <div class="col-xxl-9 col-xl-8 col-lg-7 wow fadeInUp">
            <div class="row g-4">
              <!-- Product Images and Details -->
              <div class="col-xl-6 wow fadeInUp">
                <div class="product-left-box">
                  <div class="row g-2">
                    <div class="col-xxl-12 col-lg-12 col-md-2 order-xxl-2 order-lg-2 order-md-1">
                      <div class="left-slider-image-2 left-slider no-arrow slick-top">
                        <video
                            controls
                            loop
                            muted
                            playsinline
                            preload="metadata"
                            style="width:100%; height:100%"
                            :src="listing?.video_url"
                            v-if="listing?.video_url"
                        />
                        <div v-for="image in listing?.images" :key="image.id">
                          <div class="slider-image">
                            <div class="demo-image__preview" style="z-index: 9999 !important;">
                              <el-image
                                  :src="image?.image_url"
                                  :zoom-rate="1.2"
                                  :z-index="999999"
                                  :preview-teleported="true"
                                  :preview-src-list="getImageList(listing)"
                                  :initial-index="4"
                                  fit="cover"
                                  class="img-fluid blur-up lazyload"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Product Information -->
              <div class="col-xl-6 wow fadeInUp shadow-sm" data-wow-delay="0.1s">
                <div class="right-box-contain">
                  <h2 class="name">
                    {{ listing?.name }}
                  </h2>
                  <div class="price-rating">
                    <h3 class="theme-color price">
                      {{ listing?.currency_price }}
                    </h3>
                  </div>

                  <div class="procuct-contain">
                    <p v-html="listing?.description"></p>
                  </div>

                  <!-- Seller Information -->
                  <div class="pickup-box">
                    <div class="product-title">
                      <h4>User Information</h4>
                    </div>
                    <div class="product-info">
                      <ul class="product-info-list product-info-list-2">
                        <el-space class="fa-border shadow w-100">
                          Seller :
                          <a href="javascript:void(0)">
                            <span class="fa fa-user"></span>
                            {{ listing?.user?.full_name + ' - ' + listing?.user?.listings + ' Ads.' }}
                          </a>
                        </el-space>
                        <li>Member Since : <a href="javascript:void(0)">
                          {{ formatDate(listing?.user?.created_at) }}
                        </a></li>
                        <li>Location :
                          <a href="javascript:void(0)">
                            {{ listing?.location?.name }} {{
                              listing?.location_area ? ' - ' + listing?.local_area : ''
                            }}
                          </a>
                        </li>
                        <li>
                          Seller Contact :
                          <span v-if="!seller?.phone_number">
                            <a href="javascript:void(0)" v-if="isLoggedIn"
                               class="text-white btn btn-animation btn-sm mend-auto bg-success btn-success"
                               @click="getSellerInformation">
                              <span class="fa fa-mobile-phone"></span>
                              &nbsp;Show Seller Contact
                            </a>
                            <a href="javascript:void(0)" v-else
                               class="text-white btn btn-animation btn-sm mend-auto bg-success"
                               @click="showLoginModal">
                              <span class="fa fa-mobile-phone"></span>
                              &nbsp;Show Contact
                            </a>
                          </span>
                          <a href="javascript:void(0)">
                            {{ seller?.phone_number }}
                          </a>
                        </li>
                        <li v-for="attribute in listing?.attributes" :key="attribute.id">
                          {{ attribute?.field?.name }} : <span style="color:black">{{
                            attribute?.field_value?.value || attribute?.value
                          }}</span>
                        </li>
                      </ul>
                      <div class="d-flex flex-row mt-2 shadow fa-border justify-content-around">
                        <a target="_blank"
                           :href="'https://www.facebook.com/sharer/sharer.php?u=https://sokoni.ke'+listing.link"
                           class="btn bg-primary text-white">
                          <span class="fa fa-facebook-f" style="font-size: 20px"></span>
                        </a>
                        <a target="_blank"
                           :href="'https://twitter.com/share?text='+listing.name+' at sokoni classifieds. &url=https://sokoni.ke'+listing.link"
                           class="btn fa-border text-white"
                           style="margin-left: 10px; background: #6aabde">
                          <span class="fa fa-twitter" style="font-size: 20px"></span>
                        </a>
                        <a v-if="!isLoggedIn"
                           href="javascript:void(0)"
                           @click="showLoginModal"
                           title="Login to send message"
                           class="btn bg-success text-white" style="margin-left: 10px">
                          <span class="fa fa-whatsapp" style="font-size: 20px"></span>
                        </a>
                        <a target="_blank" v-else
                           :href="getWhatsappLink()"
                           class="btn bg-success text-white" style="margin-left: 10px">
                          <span class="fa fa-whatsapp" style="font-size: 20px"></span>
                        </a>
                        <button class="align-self-end btn btn-category btn-outline-warning bg-warning"
                                style="right: 0 !important;"
                                @click="showModalReportAbuse">
                          <span class="fa fa-triangle-exclamation text-danger"></span>
                          &nbsp; Report Abuse
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Comments and Security Tips -->
              <div class="col-12 shadow">
                <div class="product-section-box">
                  <ul class="nav nav-tabs custom-nav" id="myTab" role="tablist" style="scrollbar-width: none;">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link active" id="review-tab" data-bs-toggle="tab"
                              data-bs-target="#review" type="button" role="tab"
                              aria-controls="review"
                              aria-selected="false">
                        Comments
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="info-tab" data-bs-toggle="tab"
                              data-bs-target="#info" type="button" role="tab" aria-controls="info"
                              aria-selected="false">Security Tips
                      </button>
                    </li>
                  </ul>

                  <div class="tab-content custom-tab shadow-sm p-2" id="myTabContent">
                    <div class="tab-pane fade show active" id="review" role="tabpanel"
                         aria-labelledby="review-tab">
                      <div class="review-box">
                        <div class="row g-4">
                          <div class="col-xl-12">
                            <div class="review-title">
                              <h4 class="fw-500">Add a comment</h4>
                            </div>
                            <div class="row g-4">
                              <form @submit.prevent="postComment">
                                <div class="col-12">
                                  <div class="form-floating theme-form-floating">
                                    <textarea class="form-control" v-model="comment.comment"
                                              placeholder="Leave a comment here"
                                              id="floatingTextarea2"
                                              style="height: 150px"></textarea>
                                    <span class="text-danger"
                                          v-if="errors?.data?.errors?.comment  && this.has_errors">
                                      {{ errors?.data?.errors?.comment[0] }}
                                    </span>
                                    <label for="floatingTextarea2">Write Your Comment</label>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <button class="btn btn-animation btn-sm mx-auto mt-sm-3 mt-2 w-100"
                                          v-loading="loading" v-if="isLoggedIn">
                                    Submit Comment
                                  </button>
                                  <a href="javascript:void(0)" v-else
                                     class="text-white btn btn-animation btn-sm mend-auto bg-success"
                                     @click="showLoginModal">
                                    <span class="fa fa-mobile-phone"></span>
                                    &nbsp;Submit Comment
                                  </a>
                                </div>
                              </form>
                            </div>
                          </div>
                          <div class="col-12 shadow-sm">
                            <div class="review-people">
                              <ul class="review-list">
                                <Comment :comment="_comment" v-for="_comment in listing?.comments" :key="_comment.id"/>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="info" role="tabpanel" aria-labelledby="info-tab">
                      <div class="filter-category">
                        <ol class="d-flex flex-column">
                          <li>✔️ Don't make upfront payments</li>
                          <li>✔️ Meet at a safe public location</li>
                          <li>✔️ Check the item BEFORE paying</li>
                          <li>✔️ Only pay after collecting the item</li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Sidebar -->
          <div class="col-xxl-3 col-xl-4 col-lg-5 d-lg-block wow fadeInUp shadow-sm">
            <div class="right-sidebar-box">
              <div class="vendor-box">
                <div class="container" ref="ads">
                  <AdsenseComponentDesktop/>
                </div>
              </div>

              <div class="vendor-box" v-for="business in businesses?.data" :key="business.id">
                <div class="verndor-contain">
                  <div class="vendor-image">
                    <img :src="business?.logo_url" class="blur-up lazyload" alt="">
                  </div>
                  <div class="vendor-name">
                    <h5 class="fw-500">
                      {{ business?.name }}
                    </h5>
                    <div class="product-rating mt-1">
                      <span>{{ business?.phone_number }}</span>
                    </div>
                  </div>
                </div>

                <p class="vendor-detail text-info">
                  {{ business?.description }}
                </p>
                <div class="vendor-list">
                  <ul>
                    <li>
                      <div class="address-contact">
                        <i data-feather="map-pin"></i>
                        <h5>Address: <span class="text-content">{{ business?.location }}</span></h5>
                      </div>
                    </li>
                    <li>
                      <div class="address-contact">
                        <i data-feather="headphones"></i>
                        <h5>Contact Seller: <span class="text-content">{{ business?.phone_number }}</span></h5>
                      </div>
                    </li>
                    <li>
                      <div class="address-contact">
                        <i data-feather="headphones"></i>
                        <router-link :to="'/shop/'+business?.id"
                                     class="btn btn-animation btn-sm mx-auto mt-sm-3 mt-2">
                          Shop at {{ business?.name }}
                        </router-link>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Trending Listings -->
              <TrendingListings :listing_id="listing?.id" class="d-none d-md-block"/>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div
        :class="reporting_abuse?'modal fade theme-modal view-modal show shadow-lg fa-border':'modal fade theme-modal view-modal shadow-lg fa-border'"
        id="view" tabindex="-1" aria-labelledby="exampleModalLabel"
        v-if="reporting_abuse"
        aria-modal="true" role="dialog" style="display: block; padding-left: 0px; background-color: rgba(0, 0, 0, 0.3)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header p-0">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    @click="reporting_abuse = false">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row g-sm-4 g-2">
              <div class="col-md-12">
                <br>
                <label class="f-w-300 input-label">
                  Report Category
                </label>
                <div class="form-group">
                  <el-select v-model="abuse.report_category_id"
                             placeholder="Select Report Category"
                             style="width: 100%">
                    <el-option v-for="category in abuse_categories"
                               :key="category.id"
                               :label="category.name"
                               :value="category.id">
                      {{ category?.name }}
                    </el-option>
                  </el-select>
                  <span class="text-danger"
                        v-if="errors?.data?.errors?.report_category_id  && this.has_errors">
              {{ errors?.data?.errors?.report_category_id?.[0] }}
          </span>
                </div>
              </div>
              <div class="col-md-12 mt-2">
                <el-input type="textarea" v-model="abuse.description" placeholder="Description"/>
                <span class="text-danger"
                      v-if="errors?.data?.errors?.description  && this.has_errors">
              {{ errors?.data?.errors?.description?.[0] }}
          </span>
              </div>
              <div class="col-md-12">
                <el-button @click="reporting_abuse = false">Cancel</el-button>
                <el-button type="primary" @click="submitAbuseReport" v-loading="loading">
                  Submit Report
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Related Products Section -->
    <section class="product-list-section section-b-space">
      <div class="container-fluid-lg">
        <div class="title">
          <h2>Related Products</h2>
          <span class="title-leaf"></span>
        </div>
      </div>
      <SimilarProperties :listing_id="this.$route.params.id"/>
    </section>

    <!-- Quick Auth Component -->
    <QuickAuthComponent/>
  </div>
</template>

<script>
import AppHeader from '@/components/Sections/Header'
import {mapActions, mapGetters} from 'vuex'
import FeaturedProperties from '@/components/Shared/FeatureProperties'
import SimilarProperties from '@/components/Shared/SimilarProperties'
import FooterComponent from '@/components/Sections/Footer.vue'
import GeneralController from '@/mixins/GeneralController'
import MobileFixedMenu from '@/components/Shared/MobileFixedMenu.vue'
import Comment from '@/components/Comment.vue'
import TrendingListings from '@/components/Shared/TrendingProducts.vue'
import AdsenseComponentDesktop from '@/components/AdsenseComponentDesktop.vue'
import QuickAuthComponent from '@/components/QuickAuth.vue'
import {ElImage, ElSpace, ElDialog, ElButton, ElSelect, ElOption, ElInput} from 'element-plus'
import StructuredData from "@/components/StructuredData.vue";

export default {
  name: 'PropertyDetail',
  mixins: [GeneralController],
  components: {
    ElOption, ElSelect,
    QuickAuthComponent,
    AdsenseComponentDesktop,
    TrendingListings,
    Comment,
    MobileFixedMenu,
    FooterComponent,
    SimilarProperties,
    FeaturedProperties,
    AppHeader,
    ElImage,
    ElSpace,
    ElDialog,
    ElButton,
    ElInput,
    StructuredData
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters['profile/loggedIn']
    },
    ...mapGetters({
      'listing': 'listings/listing',
      'errors': 'listings/errors',
      'has_errors': 'listings/has_errors',
      'loading': 'listings/loading',
      'categories': 'categories/categories',
      'seller': 'listings/seller_information',
      'businesses': 'businesses/businesses',
      'abuse_categories': 'categories/report_categories'
    }),
    metaInfo() {
      return {
        title: this.listing?.page_title || 'Sokoni Classifieds',
        meta: [
          {
            name: 'description',
            content: `Buy ${this.listing?.name} in Kenya at ${this.listing?.currency_price} best price on sokoni.ke 🛍️.`
          },
          {property: 'og:title', content: this.listing?.page_title || 'Sokoni Classifieds'},
          {
            property: 'og:description',
            content: `Buy ${this.listing?.name} in Kenya at ${this.listing?.currency_price} best price on sokoni.ke 🛍️.`
          },
          {
            property: 'og:image',
            content: this.listing?.images?.[0]?.image_url || 'https://sokoni.ke/assets/images/logo/sokoni.webp'
          },
          {property: 'og:url', content: window.location.href},
          {name: 'twitter:card', content: 'summary_large_image'},
          {name: 'twitter:title', content: this.listing?.page_title || 'Sokoni Classifieds'},
          {
            name: 'twitter:description',
            content: `Buy ${this.listing?.name} in Kenya at ${this.listing?.currency_price} best price on sokoni.ke 🛍️.`
          },
          {
            name: 'twitter:image',
            content: this.listing?.images?.[0]?.image_url || 'https://sokoni.ke/assets/images/logo/sokoni.webp'
          },
          {name: 'twitter:url', content: window.location.href}
        ]
      };
    }
  },
  methods: {
    submitAbuseReport() {
      this.abuse.listing_id = this.listing.id
      this.sendAbuseReport(this.abuse).then(() => {
        if (!this.has_errors) {
          this.showModalReportAbuse()
        }
      })
    },
    showModalReportAbuse() {
      if (!this.isLoggedIn) {
        return this.showLoginModal()
      }
      this.reporting_abuse = !this.reporting_abuse
    },
    getWhatsappLink() {
      let windowWidth = window.innerWidth
      let link = ''
      if (windowWidth <= 767) {
        link = 'https://wa.me/?text=Check out this ' + this?.listing?.name + ' at Sokoni Classifieds. Click https://sokoni.ke' + this?.listing?.link + ' to view.'
      } else {
        link = 'https://web.whatsapp.com/send?text=Check out this ' + this?.listing?.name + ' at Sokoni Classifieds. Click https://sokoni.ke' + this?.listing?.link + ' to view.'
      }
      return link
    },
    showLoginModal() {
      this.$store.commit('profile/setLoginModalVisible', true)
    },
    getImageList(listing) {
      let images = []
      listing?.images?.forEach(function (image) {
        images.push(image?.image_url)
      })
      return images
    },
    postComment() {
      this.comment.listing_id = this.listing.id
      this.addComment(this.comment).then(() => {
        if (!this.has_errors) {
          this.getProperty(this?.listing?.id).then(() => {
            this.listing_loaded = true
            this.$meta().refresh();
          })
          this.comment = {}
          localStorage.removeItem('draft_comment')
        }
      })
    },
    ...mapActions({
      'getProperty': 'listings/getListing',
      'updatePropertyViews': 'listings/updateListingViews',
      'getCategories': 'categories/getCategories',
      'getAbuseCategories': 'categories/getAbuseCategories',
      'getSeller': 'listings/getSeller',
      'addComment': 'listings/addComment',
      'getBusinesses': 'businesses/getBusinesses',
      'setNotificationData': 'listings/setNotificationUserHistory',
      'sendAbuseReport': 'listings/sendAbuseReport'
    }),
    getSellerInformation() {
      this.getSeller({
        'listing_id': this.listing.id
      })
    },
    updateNotificationUser() {
      let notificationUserId = localStorage.getItem('notification_player_id')
      if (notificationUserId !== undefined && notificationUserId !== null) {
        this.setNotificationData({
          'notification_user_id': notificationUserId,
          'listing_id': this.listing
        })
        this.filters.notification_player_id = notificationUserId
      }
    },
    recordPropertyView() {
      this.updatePropertyViews(this.listing?.id)
    },
    scroll() {
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    setListingTitle() {
      if (this.listing?.name !== undefined) {
        document.title = this.listing?.page_title
      } else {
        this.$router.push('/')
      }
    },
    updateDraftComment() {
      if (localStorage.getItem('draft_comment') !== null) {
        this.comment = JSON.parse(localStorage.getItem('draft_comment'))
      }
    },
    updateMetaTags() {
      this.$nextTick(() => {
        document.title = this.metaInfo.title;
        const metaTags = document.getElementsByTagName('meta');

        this.metaInfo.meta.forEach(meta => {
          let metaTag = Array.from(metaTags).find(tag => tag.getAttribute('name') === meta.name || tag.getAttribute('property') === meta.property);
          if (metaTag) {
            metaTag.setAttribute('content', meta.content);
          } else {
            let newMetaTag = document.createElement('meta');
            if (meta.name) newMetaTag.setAttribute('name', meta.name);
            if (meta.property) newMetaTag.setAttribute('property', meta.property);
            newMetaTag.setAttribute('content', meta.content);
            document.head.appendChild(newMetaTag);
          }
        });
      });
    },
  },
  mounted() {
    this.getCategories({})
    this.getAbuseCategories({})
    this.updateDraftComment()
    this.getProperty(this.$route.params.id).then(() => {
      this.listing_loaded = true
      this.recordPropertyView()
      this.updateNotificationUser()
      this.loaded = true
      this.setListingTitle()
      this.updateMetaTags();
    }).then(() => {
      this.getBusinesses({
        'category_id': [this?.listing?.listing_category_id],
        'section': 'ad_details'
      })
    })
  },
  data() {
    return {
      reporting_abuse: false,
      booking: {},
      loaded: false,
      comment: {},
      show_modal: false,
      abuse: {},
      listing_loaded: false
    }
  },
  watch: {
    'comment': {
      deep: true,
      handler: function () {
        localStorage.setItem('draft_comment', JSON.stringify(this.comment))
      }
    },
    '$route.params.id': {
      deep: true,
      immediate: true,
      handler: function () {
        this.scroll()
        this.getProperty(this.$route.params.id).then(() => {
          this.listing_loaded = true
          this.recordPropertyView()
          this.setListingTitle()
        }).then(() => {
          this.getBusinesses({
            'category_id': [this?.listing?.listing_category_id],
            'section': 'ad_details'
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.demo-image__error .image-slot {
  font-size: 30px;
}

.demo-image__error .image-slot .el-icon {
  font-size: 30px;
}

.demo-image__error .el-image {
  width: 100%;
  height: 200px;
}

.custom-form input {
  margin-bottom: 10px;
}
</style>